import Vue from 'vue';
import { checkOneTrustConsentByWindowChange } from '../utils';

Vue.component('video-player', {
    props: {
        isActive: {
            value: Boolean,
        },
        hasLoop: {
            value: Boolean,
            default: false,
        },
        youtubeId: {
            type: String,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            video: null,
            videoPlaying: false,
        };
    },

    mounted() {
        const currentSiteHandle = document
            .querySelector('body')
            .getAttribute('data-handle');

        if (currentSiteHandle === 'mgMotorsFrance') {
            setTimeout(() => {
                if (
                    !checkOneTrustConsentByWindowChange(
                        window.OnetrustActiveGroups,
                    )
                ) {
                    this.handleAddOTYTNotification();
                    return;
                }
                this.intersect();
            }, 1000);
            return;
        }
        this.intersect();
    },

    watch: {
        isActive: function (newVal, oldVal) {
            if (newVal == false) {
                this.video.pause();
                this.videoPlaying = false;
            }
        },
    },

    methods: {
        addOTYTNotification(iframe) {
            let newEl = document.createElement('div');
            newEl.innerHTML = `
            <div class="blocker">
                <p>
                    Cette vidéo est intégrée en utilisant le mode de
                    confidentialité de YouTube. En cliquant sur le
                    bouton de consentement, vous acceptez que YouTube
                    installe des cookies, établisse une connexion avec
                    Google et transfère des données personnelles à
                    Google, qui les utilisera pour analyser le
                    comportement des utilisateurs ou à des fins de
                    marketing. Pour visualiser la vidéo, à la suite de
                    l'acceptation des cookies, il est nécessaire
                    d'actualiser la page. Vous trouverez plus
                    d'informations dans notre <a href="javascript:OneTrust.ToggleInfoDisplay()">
                        avis de confidentialité.
                    </a>
                    <a class="button-v2 button-v2--border-black"
                        href="javascript:OneTrust.ToggleInfoDisplay()">
                        Modifiez mes consentements
                    </a>
                </p>
            </div>`;
            iframe.parentNode.replaceChild(newEl, iframe);
        },

        handleAddOTYTNotification() {
            let iframes = document.getElementsByTagName('iframe');
            for (const iframe of iframes) {
                let src = iframe.getAttribute('data-src');
                if (src?.includes('youtube')) {
                    this.addOTYTNotification(iframe);
                }
            }
        },

        intersect() {
            const options = {
                rootMargin: '300px',
                threshold: 0,
            };
            const video = Array.isArray(this.$refs.video)
                ? this.$refs.video[0]
                : this.$refs.video;

            const observer = new IntersectionObserver((entries, observer) => {
                const isIntersecting =
                    typeof entries[0].isIntersecting === 'boolean'
                        ? entries[0].isIntersecting
                        : entries[0].intersectionRatio > 0;
                if (isIntersecting) {
                    this.setupVideo();
                    observer.unobserve(video);
                }
            }, options);
            observer.observe(video);
        },

        playVideo(e) {
            e.preventDefault();

            this.video.play();
            this.videoPlaying = true;
        },

        /**
         * Play the intro video
         */
        async setupVideo() {
            const Plyr = await import(/* webpackChunkName: "plyr" */ 'plyr')
                .then((module) => {
                    return module.default;
                }) // using the default export
                .catch(() => {
                    console.log('Handle error!');
                });

            this.video = new Plyr(this.$refs.video, {
                settings: [
                    'play-large',
                    'play',
                    'progress',
                    'current-time',
                    'mute',
                    'volume',
                    'fullscreen',
                ],
                muted: this.hasLoop,
                loop: {
                    active: this.hasLoop,
                },
                autoplay: this.hasLoop,
            });

            if (!this.video) {
                return;
            }

            if (this.hasLoop) {
                this.videoPlaying = true;
            }

            this.video.on('ready', () => {
                if (this.hasLoop) {
                    this.video.play();
                }
            });

            this.video.on('play', (event) => {
                this.videoPlaying = true;
            });

            this.video.on('pause', (event) => {
                this.videoPlaying = false;
            });

            this.video.on('seeking', (event) => {
                this.videoPlaying = true;
            });

            this.video.on('ended', (event) => {
                this.videoPlaying = false;
            });
        },
    },
});
